import styled from '@emotion/styled';

export const Container = styled('div')`
  overflow: hidden;
  transition-property: height, opacity;

  &.slide-enter {
    opacity: 0;
  }

  &.slide-enter-active,
  &.slide-exit {
    opacity: 1;
  }

  &.slide-exit-active {
    opacity: 0;
  }
`;

interface ContainerProps {
  slideHeight?: number;
  duration: number;
}

// TODO: приходится делать так, поскольку иначе emotion затирает селекторы CSSTransition, если стили динамические
export const getContainerDynamicStyles = (props: ContainerProps) => ({
  height: props.slideHeight && `${props.slideHeight}px`,
  transitionDuration: `${props.duration}ms`
});
